import { RefreshCw } from "lucide-react";
import { useAppUpdate } from "./useAppUpdate";

// Bottom-centre so it is distinct from the toasts (bottom-left) and the version
// badge (bottom-right). Styled like the existing Toasts.
export function UpdatePrompt() {
  const { needRefresh, update } = useAppUpdate();
  if (!needRefresh) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-slate-900 text-white text-sm px-4 py-2.5 rounded-xl shadow-xl">
      <span>New version available</span>
      <button
        onClick={update}
        className="flex items-center gap-1.5 font-semibold text-teal-300 active:scale-95 transition"
      >
        <RefreshCw size={14} /> Refresh
      </button>
    </div>
  );
}
